import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
const _excluded = ["launcherComponent", "children", "dismissOnLeave", "orientation"];
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * base tooltipwrapperraw repurposed from magda, with some a11y modifications
 */
import { createRef, Component, useId } from "react";
import ReactDOM from "react-dom";
import { withTheme } from "styled-components";
import { BoxSpan } from "../../Styled/Box";
import { RawButton } from "../../Styled/Button";
import { TextSpan } from "../../Styled/Text";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @description Return a information tooltip, on hover show calculation method.
 */
class TooltipWrapperRaw extends Component {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    _defineProperty(this, "rootRef", /*#__PURE__*/createRef());
    _defineProperty(this, "tooltipTextElementRef", /*#__PURE__*/createRef());
    _defineProperty(this, "state", {
      offset: 0,
      open: !!this.props.startOpen
    });
    _defineProperty(this, "dismiss", () => {
      if (this.props.onDismiss) {
        this.props.onDismiss();
      }
      this.setState({
        open: false
      });
    });
    /**
     * get live-render-time values of tooltip ref - should already offset adjusted
     * by the time its rendered
     */
    _defineProperty(this, "getTooltipCoords", () => {
      const tooltipTextElement = this.tooltipTextElementRef.current;
      if (!tooltipTextElement) {
        return {
          x: 0,
          y: 0
        };
      }
      const {
        x,
        y,
        width,
        height
      } = tooltipTextElement.getBoundingClientRect();
      const maxX = document.documentElement.clientWidth - width;
      const maxY = document.documentElement.clientHeight - height;
      // make sure the tooltip doesn't get clipped by the browser edges
      const adjustedX = x < 10 ? 10 : x > maxX ? maxX - 10 : x;
      const adjustedY = y < 10 ? 10 : y > maxY ? maxY - 10 : y;
      return {
        x: adjustedX,
        y: adjustedY
      };
    });
    _defineProperty(this, "forceSetState", function () {
      let bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      _this.setState({
        open: bool
      });
    });
  }
  componentDidMount() {
    if (!this.props.disableEventListeners) {
      document.addEventListener("mousedown", this.dismiss);
      document.addEventListener("touchstart", this.dismiss);
    }
    this.adjustOffset();
  }
  componentDidUpdate() {
    this.adjustOffset();
  }
  componentWillUnmount() {
    if (!this.props.disableEventListeners) {
      document.removeEventListener("mousedown", this.dismiss);
      document.removeEventListener("touchstart", this.dismiss);
    }
  }
  /**
   * Adjust the offset margin of the tooltiptext so it's at the centre of the launcher.
   */
  adjustOffset() {
    const tooltipTextElement = this.tooltipTextElementRef.current;
    const rootElement = this.rootRef.current;

    // Why .firstChild? Because we can't attach a ref to a render prop unless whatever's passed in passes the ref through to its first dom element
    const launcherElement = rootElement === null || rootElement === void 0 ? void 0 : rootElement.firstChild;
    if (!launcherElement || !tooltipTextElement) {
      return;
    }
    const launcherElementStyle = launcherElement.currentStyle || window.getComputedStyle(launcherElement);
    const tooltipWidth = tooltipTextElement.offsetWidth;
    const offset = (tooltipWidth + parseFloat(launcherElementStyle.marginLeft) + parseFloat(launcherElementStyle.marginRight) - parseFloat(launcherElementStyle.paddingRight) - parseFloat(launcherElementStyle.paddingLeft)) / 2;
    // only update if the difference is big enough to prevent indefinite loop caused by browser sub pixel error
    // FIXME: this test however passes in safari mobile each time resulting in a inifinite render loop
    if (Math.abs(this.state.offset - offset) > 5) {
      this.setState({
        offset: offset
      });
    }
  }
  render() {
    const {
      orientation,
      theme,
      innerElementStyles
    } = this.props;
    const orientationBelow = orientation === "below";
    // default to above
    const orientationAbove = orientation === "above" || orientation === undefined;
    return /*#__PURE__*/_jsxs(_StyledSpan, {
      ref: this.rootRef,
      children: [this.props.launcher && this.props.launcher({
        state: this.state,
        launch: () => this.forceSetState(true),
        forceSetState: this.forceSetState
      }), this.state.open && /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/_jsx(_StyledBoxSpan, {
        paddedRatio: 3,
        position: "absolute",
        rounded: true,
        style: _objectSpread({}, innerElementStyles),
        $_css: theme.frontComponentZIndex + 999999 + 2,
        $_css2: theme.textDark,
        $_css3: theme.textLight,
        $_css4: this.getTooltipCoords().y,
        $_css5: this.getTooltipCoords().x,
        children: this.props.children(true, this.dismiss)
      }), document.body), /*#__PURE__*/_jsx(_StyledBoxSpan2, {
        paddedRatio: 3,
        position: "absolute",
        ref: this.tooltipTextElementRef,
        style: _objectSpread({
          marginLeft: "-" + this.state.offset + "px"
        }, innerElementStyles)
        /**
         caret styles if we need them again
        &::after {
            content: "";
            position: absolute;
            left: 50%;
            margin-left: -10px;
            border-width: 10px;
            border-style: solid;
          }
          ${orientationBelow &&
            `&::after {
              bottom: 100%;
              border-color: transparent transparent ${theme.textDark} transparent;
          `}
          ${orientationAbove &&
            `&::after {
              top: 100%;
              border-color: ${theme.textDark} transparent transparent transparent;
          `}
         */,
        $_css6: orientationAbove && "bottom: calc(100% + 10px);",
        $_css7: orientationBelow && "top: calc(100% + 10px);",
        children: this.props.children(false, this.dismiss)
      })]
    });
  }
}
export const TooltipWrapper = withTheme(TooltipWrapperRaw);
export const TooltipWithButtonLauncher = props => {
  const {
      launcherComponent,
      children,
      dismissOnLeave,
      orientation
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const idForAria = useId();
  const idForChildAria = useId();
  return /*#__PURE__*/_jsx(TooltipWrapper, _objectSpread(_objectSpread({
    innerElementStyles: {
      width: "350px"
    },
    orientation: orientation || "below"
  }, rest), {}, {
    disableEventListeners: true,
    launcher: launchObj => {
      const handleClose = () => {
        if (launchObj.state.open) {
          launchObj.forceSetState(false);
        }
      };
      const restButtonProps = dismissOnLeave ? {
        onMouseLeave: () => handleClose(),
        onBlur: () => handleClose()
      } : {};
      return /*#__PURE__*/_jsx(_StyledRawButton, _objectSpread(_objectSpread({
        "aria-expanded": launchObj.state.open,
        "aria-describedby": "".concat(idForAria, " ").concat(idForChildAria),
        onClick: () => launchObj.forceSetState(!launchObj.state.open),
        onFocus: launchObj.launch,
        onMouseOver: () => {
          if (!launchObj.state.open) {
            launchObj.launch();
          }
        }
      }, restButtonProps), {}, {
        $_css8: "text-decoration: underline dashed;",
        children: launcherComponent()
      }));
    },
    children: applyAriaId => /*#__PURE__*/_jsx(TextSpan
    // provide some base text styles as a textspan,
    // as this will be rendered outside the tree
    , {
      large: true,
      semiBold: true,
      id: applyAriaId && idForAria || undefined,
      children: children(applyAriaId && idForChildAria || "")
    })
  }));
};
export default TooltipWrapper;
var _StyledSpan = _styled("span")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          position: relative;\n          display: inline-block;\n        "])));
var _StyledBoxSpan = _styled2(BoxSpan)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                // TODO: find offending z-index - likely still in scss\n                z-index: ", ";\n                background-color: ", ";\n                color: ", ";\n                text-align: left;\n                top: ", "px;\n                left: ", "px;\n              "])), p => p.$_css, p => p.$_css2, p => p.$_css3, p => p.$_css4, p => p.$_css5);
var _StyledBoxSpan2 = _styled3(BoxSpan)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            visibility: hidden;\n            left: 50%;\n\n            ", "\n            ", "\n          "])), p => p.$_css6, p => p.$_css7);
var _StyledRawButton = _styled4(RawButton).withConfig({
  displayName: "TooltipWrapper___StyledRawButton",
  componentId: "sc-10qgwlf-0"
})(["", ""], p => p.$_css8);